import { useNavigation } from "../../../hooks/useNavigation";
import { useCallback } from "react";
import { authActions } from "../../../ducks/auth";
import { PageRoute } from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";

export const useResetPasswordPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { navigateToPage } = useNavigation();

    const handleResetPassword = useCallback(
        (new_password: string, uid: string, token: string, onError: (message: string) => void) => {
            dispatch(
                authActions.resetPassword.started({
                    new_password,
                    uid,
                    token,
                    onSuccess: () => {
                        navigateToPage(PageRoute.LOGIN);
                    },
                    onError: (error) => {
                        let message = "Failed to reset password. Please try again.";

                        // Extract user-friendly error message from backend response
                        if (error?.response?.data) {
                            const data = error.response.data;
                            if (typeof data === 'string') {
                                message = data;
                            } else if (typeof data === 'object') {
                                const dataObj = data as Record<string, unknown>;
                                if (dataObj.detail) {
                                    // Handle "detail" field (can be string or array)
                                    if (typeof dataObj.detail === 'string') {
                                        message = dataObj.detail;
                                    } else if (Array.isArray(dataObj.detail)) {
                                        message = dataObj.detail.join(' ');
                                    }
                                } else if (dataObj["error-code"]) {
                                    message = String(dataObj["error-code"]);
                                }
                            }
                        }
                        // Avoid raw Axios error messages like "Request failed with status code 400"

                        onError(message);
                    },
                })
            );
        },
        [dispatch, navigateToPage]
    );

    return { handleResetPassword };
};
